<template>
  <div v-show="cbox.visible">
    <div
      class="modal"
      style="display: block; background: rgba(0, 0, 0, 0.4)"
    ></div>
    <div
      class="modal-dialog"
      style="position: fixed; left: 400px; top: 150px; z-index: 8888"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: black">{{ cbox.title }}</h4>
        </div>
        <div class="modal-body">
          <div style="margin: 5px; display: flex">
            <span
              class="glyphicon icon-alertbox-size"
              id="icon"
              :class="{

                'glyphicon-info-sign icon-severity-info':
                  cbox.action === 'upgrade' || cbox.action === 'configFile' 
                  || cbox.action === 'copyConfig' || cbox.action === 'reboot',
              }"
            ></span>
            <span style="margin: 3px 15px">{{ cbox.txt }}</span>
          </div>
        </div>
        <div class="modal-footer" v-if="cbox.type == 'wait'">
          
        </div>
        <div class="modal-footer" v-else-if="cbox.type == 'end'">
          <button
            class="btn btn-primary"
            type="button"
            @click="closeConfirmBox()"
          >
            {{ "Close" }}
          </button>
        </div>
        <div class="modal-footer" v-else-if="cbox.type == 'confirm'">
          <button
            class="btn btn-primary"
            type="button"
            @click="confirmApply()"
          >
            {{ "Yes" }}
          </button>
          <button
            class="btn btn-default"
            type="button"
            @click="closeConfirmBox()"
          >
            {{ "No" }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirmBox",

  data() {
    return {}
  },
  props: {
    cbox: {
      type: Object,
      default: function () {
        return {
          visible: false,
          action: "",
          type: "",
          title: "", 
          txt: "",
        }
      },
    },
  },
  methods: {
    closeConfirmBox() {
      this.cbox.visible = false
      /*
      if(this.cbox.action == "upgrade") {
        this.$emit('upgrade-event', '0')
      } else if(this.cbox.action == "configFile") {
        this.$emit('configFile-event', '0')
      } else if(this.cbox.action == "copyConfig") {
        this.$emit('copyConfig-event', '0')
      } else if(this.cbox.action == "reboot") {
        this.$emit('reboot-event', '0')
      }
      */
    },
    confirmApply() {
      this.cbox.visible = false
      if(this.cbox.action == "upgrade") {
        this.$emit('upgrade-event', '1')
      } else if(this.cbox.action == "configFile") {
        this.$emit('configFile-event', '1')
      } else if(this.cbox.action == "copyConfig") {
        this.$emit('copyConfig-event', '1')
      } else if(this.cbox.action == "reboot") {
        this.$emit('reboot-event', '1')
      }
    }
  },
}
</script>

<style lang="less" scoped>

</style>
 
